import React, { useState, useEffect } from "react";
import { Table, Icon, Input } from "semantic-ui-react";
import { map } from "lodash";
import { Button } from "semantic-ui-react";
import "../TablePeriodos/TablePeriodos.css";
import { Tooltip } from "react-tooltip";

export function TablePlanDeEstudios(props) {
  const { planDeEstudios, deletePlanDeEstudio, updatePlanDeEstudio } = props;
  const itemsPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
  }, [searchText]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setSearchText(realTimeSearch.toLowerCase());
  }, [realTimeSearch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredPlan = planDeEstudios.filter((plan) =>
    plan.descripcion.toLowerCase().includes(searchText.toLowerCase())
  );

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    if (searchText === "") {
      setCurrentPage(1);
    }
  }, [searchText, setCurrentPage]);

  useEffect(() => {
    const lastPage = Math.ceil(filteredPlan.length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [filteredPlan, currentPage, setCurrentPage]);

  const paginatedPlan = filteredPlan.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <div>
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por plan"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          className="busper"
        />
      </div>
      <div>
        <Table className="table-users-admin">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>PLAN DE ESTUDIOS</Table.HeaderCell>
              <Table.HeaderCell>ACCIONES</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {map(paginatedPlan, (plan, index) => (
              <Table.Row key={index}>
                <Table.Cell>{plan.descripcion}</Table.Cell>
                <Actions
                  planDeEstudio={plan}
                  deletePlanDeEstudio={deletePlanDeEstudio}
                  updatePlanDeEstudio={updatePlanDeEstudio}
                />
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(planDeEstudios.length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(planDeEstudios.length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(planDeEstudios.length / itemsPerPage);

            //para evitar renderizar el botón si solo hay una página
            if (Math.ceil(planDeEstudios.length / itemsPerPage) === 1) {
              return null;
            }

            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(planDeEstudios.length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}
function Actions(props) {
  const { planDeEstudio, deletePlanDeEstudio, updatePlanDeEstudio } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Actualizar plan de estudio"
          icon
          className="yellow"
          onClick={() => {
            updatePlanDeEstudio(planDeEstudio);
          }}
        >
          <Icon name="pencil" style={{ color: "white" }}></Icon>
        </Button>
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Eliminar plan de estudio"
          icon
          negative
          onClick={() => {
            deletePlanDeEstudio(planDeEstudio);
          }}
        >
          <Icon name="trash" style={{ color: "white" }}></Icon>
        </Button>
        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
